import React from 'react';

export const context = { formState: React.createContext({}) };
export const useFormState = () => React.useContext(context.formState);

export default context;
